import { CommonState } from "../enums/common.enum";
export const COMMON_STATES = [CommonState.DISABLED, CommonState.ENABLED];
export const common_state_options = [{
  label: 'Không hoạt động',
  value: CommonState.DISABLED
}, {
  label: 'Hoạt động',
  value: CommonState.ENABLED
}];
//# sourceMappingURL=common.constant.js.map